import PosterIframeBuilder from './poster-iframe-builder';
import WidgetV2IframeBuilder from './widget-v2-iframe-builder';
import Iab300x250IframeBuilder from './ad-300-iframe-builder';
import LeaderboardIframeBuilder from './leaderboard-iframe-builder';
import PublisherIframeBuilder from './publisher-iframe-builder';

const builderMap = {
  poster: PosterIframeBuilder,
  'widget-v2': WidgetV2IframeBuilder,
  'iab-300x250': Iab300x250IframeBuilder,
  'iab-leaderboard': LeaderboardIframeBuilder,
  publisher: PublisherIframeBuilder,
};

export default class BuilderMap {
  static get(builderType) {
    return builderMap[builderType] || PosterIframeBuilder;
  }
}



// WEBPACK FOOTER //
// ./src/utils/builder_map.js